import { render, staticRenderFns } from "./BlockFeed.vue?vue&type=template&id=7c3fc3c9&scoped=true&"
import script from "./BlockFeed.vue?vue&type=script&lang=js&"
export * from "./BlockFeed.vue?vue&type=script&lang=js&"
import style0 from "./BlockFeed.vue?vue&type=style&index=0&id=7c3fc3c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3fc3c9",
  null
  
)

export default component.exports